module.exports = __webpack_public_path__ + "static/media/rotate_ccw.a8c4c68a.png";